export enum ContainerType {
  ONE_COLUMN = '1',
  TWO_COLUMNS = '2'
}
